import api from '@/plugins/request/index';

// 销售报表核心数据
export const getSaleCore = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/core-report`, params).then(res => res);
}
// 销售报表核心数据导出
export const exportSaleCore = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/core-report/export`, params).then(res => res);
}
// 销售报表客户来源分析
export const getSaleOriginAnalysis = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-analyze-source`, params).then(res => res);
}
// 销售报表新增客户分布分析
export const getSalePlaceAnalysis = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-analyze-status`, params).then(res => res);
}
// 销售报表新增客户渠道分析
export const getSaleChannelAnalysis = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-analyze-channel`, params).then(res => res);
}
// 销售报表导出
export const exportSaleReport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/core-report/export`, params).then(res => res);
} 
// 销售漏斗核心统计
export const getFunnelCore = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/core-node-report`, params).then(res => res);
} 
// 销售漏斗数据分析
export const getFunnelAnalysis = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/sale-analysis`, params).then(res => res);
} 
// 销售榜单开单王
export const getRankListTop = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/ranking-top`, params).then(res => res);
} 
// 销售榜单销售排行
export const getRankListSale = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/ranking-report`, params).then(res => res);
}
// 销售榜单导出
export const exportRankListSale = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/ranking-report/export`, params).then(res => res);
}
// 任务报表总览
export const getTaskPandect = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task-report/common/overview`, params).then(res => res);
}
// 任务报表列表
export const getTaskDetail = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task-report/common/show-list`, params).then(res => res);
}
// 公司报表-商户新增客户数据
export const getCompanyExplain = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/company-explain`, params).then(res => res);
}
// 日志报表业务明细
export const getDayBussinessDetail = async (params, type = 'get') => {
  return api[type](`/gateway/v1/statistics/operate-statistics/business-detail`, params).then(res => res);
}
// 日志报表获取经纪人详情
export const getDayUserDetail = async (id, type = 'get') => {
  return api[type](`/gateway/v1/admin/${id}/with-dept-tree`).then(res => res);
}
// 日志报表获取经纪人对应明细
export const getDayUserBussinessDetail = async (params, type = 'get') => {
  return api[type](`/gateway/v1/statistics/operate-statistics/admin-customer-follow`, params).then(res => res);
}
// 员工分析-按日期获取员工分析数据
export const getDailyExplain = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/daily-explain`, params).then(res => res);
}
// 员工分析-按经纪人获取员工分析数据
export const getPeriodExplain = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/period-explain`, params).then(res => res);
}

// 员工分析-按部门获取员工分析数据
export const getDepartmentExplain = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/dept-explain`, params).then(res => res);
}
// 员工分析-按日期查询-单个详情
export const getDailyExplainInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/daily-explain/customer-info`, params).then(res => res);
}
// 员工分析-按经纪人查询-单个详情
export const getPeriodExplainInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/period-explain/customer-info`, params).then(res => res);
}
// 员工分析-总计详情
export const getTotalExplainInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/total-explain/customer-info`, params).then(res => res);
}
// 员工分析-项目跟进列表
export const getDayProjectList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/project-explain`, params).then(res => res);
}
// 员工分析-按日期查询-单个详情导出
export const exportDailyExplainInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/daily-explain/customer-info/export', params).then(res => res);
}
// 员工分析-按经纪人查询-单个详情导出
export const exportPeriodExplainInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/period-explain/customer-info/export', params).then(res => res);
}
// 员工分析-总计详情导出
export const exportTotalExplainInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/total-explain/customer-info/export`, params).then(res => res);
}
// 员工分析-可数数量导出
export const exportCustomerExplain = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/customer-explain/export', params).then(res => res);
}
// 员工跟进转化- 客户详情
export const getExplainCustomeInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/period-explain/customer-info`, params).then(res => res);
}
// 员工跟进转化- 客户详情总计
export const getTotalExplainCustomeInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/total-explain/customer-info`, params).then(res => res);
}
// 员工跟进转化- 跟进详情
export const getExplainFollowInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/period-explain/follow-info`, params).then(res => res);
}
// 员工跟进转化- 跟进详情总计
export const getTotalExplainFollowInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/total-explain/follow-info`, params).then(res => res);
}
// 员工跟进转化- 业务详情
export const getExplainBussiInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/period-explain/business-info`, params).then(res => res);
}
// 员工跟进转化- 业务详情总计
export const getTotalExplainBussiInfo = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/total-explain/business-info`, params).then(res => res);
}
// 员工跟进转化- 客户详情导出
export const exportExplainCustomeInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/period-explain/customer-info/export', params).then(res => res);
}
// 员工跟进转化- 客户详情总计导出
export const exportTotalExplainCustomeInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/total-explain/customer-info/export', params).then(res => res);
}
// 员工跟进转化- 跟进详情导出
export const exportExplainFollInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/period-explain/follow-info/export', params).then(res => res);
}
// 员工跟进转化- 跟进详情总计导出
export const exportTotalExplainFollInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/total-explain/follow-info/export', params).then(res => res);
}
// 员工跟进转化- 业务详情导出
export const exportExplainBussInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/period-explain/business-info/export', params).then(res => res);
}
// 员工跟进转化- 业务详情总计导出
export const exportTotalExplainBussInfo = async (params, type = 'get') => {
  return api[type]('/gateway/v1/report/total-explain/business-info/export', params).then(res => res);
}
// 员工跟进转化- 导出
export const exportBusinessExplain = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/business-explain/export`, params).then(res => res);
}
export const exportPrintBussiness = async (params, type = 'get') => {
  return api[type](`/gateway/v1/statistics/operate-statistics/print-business-detail`, params).then(res => res);
}
// 员工跟进-首次跟进汇总
export const getFirstFollowTotal = async (params, type = 'get') => {
  return api[type](`/gateway/v1/first-follow/statistic`, params).then(res => res);
}
// 员工跟进-首次跟进明细
export const getFirstFollowList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/first-follow/list`, params).then(res => res);
}
// 员工跟进- 首次跟进汇总导出
export const exportFirstFollowTota = async (params, type = 'get') => {
  return api[type](`/gateway/v1/first-follow/statistic/export`, params).then(res => res);
}
// 员工跟进- 首次跟进明细导出
export const exportFirstFollowList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/first-follow/list/export`, params).then(res => res);
}
// 客户分析-客户明细
export const getCustomerDetailList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-list`, params).then(res => res);
}
// 客户分析-汇总数据
export const getCustomerTotal = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-board`, params).then(res => res);
}
// 客户分析- 客户明细导出
export const exportCustomerList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/customer-list/export`, params).then(res => res);
}
// 400分析-客户明细
export const getCallDetailList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/call-list`, params).then(res => res);
}
// 400分析-汇总数据
export const getCallTotal = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/call-board`, params).then(res => res);
}
// 400分析- 客户明细导出
export const exportCallList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/call-list/export`, params).then(res => res);
}
// IM分析-客户明细
export const getImDetailList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/im-list`, params).then(res => res);
}
// IM分析-汇总数据
export const getImTotal = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/im-board`, params).then(res => res);
}
// IM分析- 客户明细导出
export const exportImList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/im-list/export`, params).then(res => res);
}